import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import styles from './GenericStatus.module.scss'

const GenericStatus = ({ status }) => {
  return (
    <span
      className={classNames(styles.status, {
        [`status-${status.toLowerCase()}`]: true
      })}
    >
      {status}
    </span>
  )
}

GenericStatus.propTypes = {
  status: PropTypes.string.isRequired
}

export default GenericStatus
